var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dagre-com"},[_c('div',{staticClass:"minimap",attrs:{"id":'minimap'+_vm.poolId}}),_c('div',{ref:"container",staticStyle:{"position":"relative"},attrs:{"id":'container'+_vm.poolId}})])}
var staticRenderFns = []

export { render, staticRenderFns }